import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt, faGripLines, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ReactDragListView from 'react-drag-listview'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class ServiceColumns extends Component {

  standardRow = (serviceColumn) => {
    this.props.info('ServiceColumns.js/standardRow (serviceColumn)', serviceColumn);
    return (
      <Row className="adminRow pointer serviceColumnRow" onClick={() => this.props.onEdit(serviceColumn.serviceColumnId)}>
        <Col md={4} className="text-left">
          <FontAwesomeIcon icon={(serviceColumn['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((serviceColumn['active']) ? 'iconActive' : 'iconInactive')} />
          {serviceColumn['column']}
        </Col>
        <Col md={7} className="text-left">{serviceColumn['section']}</Col>
        {this.props.editServiceColumn.serviceColumnId === 0 ? 
        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Reorder Service Columns">
          <Col md={1} className="text-right" >
            <span className="dragIconServiceColumn p-2"><FontAwesomeIcon icon={faGripLines} /></span>
          </Col>
        </PermissionWrapper> : <></>}
      </Row>
    )
  }

  editRow = (serviceColumn) => {
    this.props.log('ServiceColumns.js/editRow (serviceColumn)', serviceColumn);
    return (
      <Row className="editRow adminRow activeTab">
        <Col md={9} className="text-left">
          <Form inline>
            <FormGroup className="pr-2">
              <Input
                placeholder="Column"
                type="text"
                id="serviceColumn-edit-column"
                name="column"
                value={this.props.isFieldNull(this.props.editServiceColumn.column)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2">
              <Input
                placeholder="Section"
                type="text"
                id="serviceColumn-edit-section"
                name="section"
                value={this.props.isFieldNull(this.props.editServiceColumn.section)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2">
              <Input
                placeholder="Type"
                type="text"
                id="serviceColumn-edit-type"
                name="type"
                value={this.props.isFieldNull(this.props.editServiceColumn.type)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"serviceColumn-edit-active" + serviceColumn.serviceColumnId}
                name="active"
                checked={this.props.isFieldNull(this.props.editServiceColumn.active,true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"serviceColumn-edit-active" + serviceColumn.serviceColumnId}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={3} className="text-right">
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Service Columns">
            <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Service Column">
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          </PermissionWrapper>
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Service Columns">
            <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(serviceColumn.serviceColumnId)} edit="Delete Service Column">
              <FontAwesomeIcon icon={faTrashAlt} />
            </ConfirmButton>
          </PermissionWrapper>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col md={4} className="text-right p-3">
          Assigned Services
        </Col>
        <Col md={8} className="text-left px-5 pt-3 maxHpanel">
          {this.props.services.filter(parentService => parentService.services != null).map(parentService => (
            parentService.services.map(service => (
              <div key={"service-" + service.serviceId}><Label for={"service_" + service.serviceId}>
                <Input
                  type="checkbox"
                  name="services"
                  id={"service_" + service.serviceId + "_" + serviceColumn.serviceColumnId}
                  checked={this.props.isFieldNull(this.props.editServiceColumn.services.findIndex(i => i.serviceId === parseInt(service.serviceId)) > -1,true)}
                  onChange={e => this.props.onChange(e, 'edit')}
                />
                {parentService.name} <FontAwesomeIcon className="small mx-2" icon={faChevronRight} /> {service['name']}
              </Label></div>
            ))
          )
          )}
        </Col>
      </Row>
    )
  }

  addRow = () => {
    this.props.info('ServiceColumns.js/standardRow');
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col md={10}>
          <Form inline>
            {/* <FormGroup className="pr-2">
              Add New Column
            </FormGroup> */}
            <FormGroup className="pr-2">
              <Input
                placeholder="New Column Name"
                type="text"
                id="serviceColumn-add-column"
                name="column"
                value={this.props.isFieldNull(this.props.newServiceColumn.column)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2">
              <Input
                placeholder="Identifier"
                type="text"
                id="serviceColumn-add-section"
                name="section"
                value={this.props.isFieldNull(this.props.newServiceColumn.section)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2">
              <Input
                placeholder="Column Type"
                type="text"
                id="serviceColumn-add-type"
                name="type"
                value={this.props.isFieldNull(this.props.newServiceColumn.type)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2">
              <Input
                type="checkbox"
                id={"serviceColumn-add-active"}
                name="active"
                checked={this.props.isFieldNull(this.props.newServiceColumn.active,true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"serviceColumn-add-active"}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={2} className="text-right">
          <Button
            disabled={this.props.newServiceColumn.name === ''}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Column</Button>
        </Col>
      </Row>
    )
  }

  render() {
    this.props.info('ServiceColumns.js/render');
    return (
      <Container className="adminContainer" fluid>
        <ReactDragListView {...this.props.dragPropsServiceColumn}>
          {this.props.serviceColumns.map(serviceColumn => (
            <Fragment key={"serviceColumn-" + serviceColumn.serviceColumnId}>{this.props.editServiceColumn.serviceColumnId === serviceColumn.serviceColumnId ? this.editRow(serviceColumn) : this.standardRow(serviceColumn)}</Fragment>
          ))}
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Service Columns">
            {this.addRow()}
          </PermissionWrapper>
        </ReactDragListView>
      </Container>
    );

  }
}

export default ServiceColumns;